<template>
  <div id="hold">
<headers></headers>

<div class="row widu" style="margin:0 auto;margin-top:10px">
<div class="span6">
<ul class="breadcrumb">
<span style="color:#999">当前位置：</span>
<li>
<a href="/">网站首页</a> <span class="divider">></span>
</li>
<li class="active" style="color:#999">留货</li>
</ul>
</div>
</div>

<div style="margin:0 auto" class="widu">
留货
<table border='1' style='border-collapse:collapse;' class="widu" cellspacing='0'>
<tr style="background:#FFF" >
<td>ID</td><td>证书类型</td><td>产品编号</td><td>证书号</td><td>形状</td>
<td>
重量
</td>

<td>
颜色
</select>
</td>

<td>
净度
</td>
<td>国际报价</td><td>退点</td><td>单价</td><td>金额</td>
<td>
切工</td><td>抛光</td><td>对称</td><td>荧光</td><td>尺寸</td><td>台面%</td><td>亭深%</td><td>查询证书</td><td>---</td></tr>

<tr onmouseover="this.style.background='orange'" onmouseout="this.style.background=''" v-for="diamond in diamonds" :class="{on:diamond.id%2==0,off:diamond.id%2!=0}">
<td>{{diamond.id}}</td>
<td>{{diamond.jdzs}}</td>

<td>{{diamond.hao}}</td>
<td>{{diamond.zsh}}</td>
<td>{{diamond.xz}}</td>
<td>{{diamond.zl}}</td>
<td>{{diamond.yc}}</td>
<td>{{diamond.jd}}</td>
<td>{{diamond.mjbj}}</td>
<td>{{diamond.zk}}</td>
<td>{{diamond.dj}}</td>

<td>{{diamond.zje}}</td>
<td>{{diamond.qg}}</td>
<td>{{diamond.pg}}</td>
<td>{{diamond.dc}}</td>
<td>{{diamond.yg}}</td>
<td>{{diamond.cc}}</td>
<td>{{format(diamond.tm)}}</td>
<td>{{format(diamond.sd)}}</td>
<td>
<a v-bind:href="'https://www.gia.edu/CN/report-check?reportno=' + diamond.zsh" onclick="alert(diamond.zsh)" target='_blank'>查询证书</a>
</td>
<td><button style="white-space:nowrap" v-on:click="delCart(diamond.zsh)">删除</button></td>
</tr>
</table>
<div style="text-align:center;margin-top:20px;margin-bottom:20px">
<button type="button" class="btn btn-primary" v-on:click="checkout()" style="color:#999">确认提交订单</button>
</div>

</div>


<div style="clear:both;"></div>
   <div class="footer" style="margin:0 auto">
                <div class="wrap">
                    <div class="footer-in">

                        <div class="footer-navs">
                            <a href="/" class="fn-index">首页</a><b>|</b>
                            <a href="/vi" class="fn-diamond">在线浏览</a><b>|</b>
                                <a href="/contact" class="fn-login">联系我们</a>
                                                    </div>

                    </div>
                </div>
            </div>


  </div>
</template>

<script>

export default {
  name: 'Hold',
  data(){
  return {
  title:"购物车",
  token:localStorage.authorization,
  url:'',
  hold_url:'https://www.giazh.com/auth/hold/delete',
  hl:'',
  tips:'',
  loading:false,
  diamonds:[]
  }
  },
  methods:{
    format: function(value) {
              return  Math.round(value * 100) / 100;
            },
     delCart: function(zsh) {

	      this.$http.post(this.hold_url,{zsh:zsh},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
	    console.log('2222',data);
	    window.location.reload(true);
	    }).catch(err => {
				console.log(err);
				//localStorage.clear();
				//alert('已退出');
				//window.location.reload(true);
			      });

            },
     getData: function (type,value) {
     if(this.token){
		 this.url="https://www.giazh.com/auth/hold";
		 }else{
		 this.url="https://www.giazh.com/auth/hold";
		 }
          this.$http.post(this.url,{},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
	    console.log('2222',data);
	    this.diamonds=data.body;
	    }).catch(err => {
				console.log(err);
				//localStorage.clear();
				alert('已退出');
				//window.location.reload(true);
			      });
    },
     checkout: function () {
          this.$http.post("https://www.giazh.com/auth/order/addhold",{},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
	    console.log('333',data);
	    if(data.body=='ok'){
	    this.$router.push('/order');
	    }
	    }).catch(err => {
				console.log(err);
				//localStorage.clear();
				alert('已退出');
				//window.location.reload(true);
			      });
    }
  },
  components:{
  },
  created(){
	       if(this.token){
		 this.url="https://www.giazh.com/auth/vi";
		 }else{
		  this.url="https://www.giazh.com/api/vi";
		 }
		    this.getData();

  }
}
</script>



<style scoped>
table td{height:25px;text-align:center;color:#000;word-break: keep-all;white-space:nowrap;}
    .on {
      background: #c7eaf9;
    }
    .off {
      background: #ffffff;
    }

    table td a{color:blue}



</style>


// WEBPACK FOOTER //
// src/components/Hold.vue